

export const frontMatter = {
	sidebar_position: 70
};
export const contentTitle = 'Derivative';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-features-filters-derivative-md-3be.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import DerivativeDemo from './demos//derivative.demo.tsx';
export const toc = [{
  "value": "Kinds of images compatible with algorithm",
  "id": "kinds-of-images-compatible-with-algorithm",
  "level": 3
}, {
  "value": "Parameters and default values",
  "id": "parameters-and-default-values",
  "level": 3
}, {
  "value": "Options",
  "id": "options",
  "level": 4
}, {
  "value": "Sobel kernel",
  "id": "sobel-kernel",
  "level": 2
}, {
  "value": "Scharr kernel",
  "id": "scharr-kernel",
  "level": 2
}, {
  "value": "Prewitt kernel",
  "id": "prewitt-kernel",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    admonition: "admonition",
    annotation: "annotation",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    math: "math",
    mi: "mi",
    mn: "mn",
    mo: "mo",
    mrow: "mrow",
    mstyle: "mstyle",
    mtable: "mtable",
    mtd: "mtd",
    mtr: "mtr",
    p: "p",
    path: "path",
    pre: "pre",
    semantics: "semantics",
    span: "span",
    svg: "svg",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "derivative",
        children: "Derivative"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.em, {
        children: "Gradient filter but using predefined kernels."
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.a, {
        href: "https://image-js.github.io/image-js-typescript/classes/Image.html#derivativeFilter",
        title: "link on github io",
        children: ["🖼️ Image options and parameters of ", _jsx(_components.code, {
          children: "derivative"
        }), " method"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Derivative filter is a special case of a gradient filter, therefore it uses gradient algorithm. However, the key difference are the kernels used in this very algorithm. In ImageJS there are three distinguished kernels: ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Sobel_operator",
        title: "wikipedia link on Sobel kernel",
        children: "Sobel"
      }), ", ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Sobel_operator#Alternative_operators",
        title: "wikipedia link on Scharr operator",
        children: "Scharr"
      }), " and ", _jsx(_components.a, {
        href: "https://en.wikipedia.org/wiki/Prewitt_operator",
        title: "wikipedia link on Prewitt kernel",
        children: "Prewitt"
      }), "."]
    }), "\n", _jsx(DerivativeDemo, {}), "\n", _jsx(_components.h3, {
      id: "kinds-of-images-compatible-with-algorithm",
      children: "Kinds of images compatible with algorithm"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Image property"
          }), _jsx(_components.th, {
            children: "What it means"
          }), _jsx(_components.th, {
            children: "Possible values"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "bitDepth"
            })
          }), _jsx(_components.td, {
            children: "number of bits per channel"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[8,16]"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "components"
            })
          }), _jsx(_components.td, {
            children: "number of components"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "[1]"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "alpha"
            })
          }), _jsx(_components.td, {
            children: "is alpha channel allowed"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "true"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "parameters-and-default-values",
      children: "Parameters and default values"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "options"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "options",
      children: "Options"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Property"
          }), _jsx(_components.th, {
            children: "Required"
          }), _jsx(_components.th, {
            children: "Default value"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/DerivativeFilterOptions.html#bitDepth",
              children: _jsx(_components.code, {
                children: "bitDepth"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "image.bitDepth"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/DerivativeFilterOptions.html#borderType",
              children: _jsx(_components.code, {
                children: "borderType"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "replicate"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/DerivativeFilterOptions.html#borderValue",
              children: _jsx(_components.code, {
                children: "borderValue"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "0"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "https://image-js.github.io/image-js-typescript/interfaces/DerivativeFilterOptions.html#filter",
              children: _jsx(_components.code, {
                children: "filter"
              })
            })
          }), _jsx(_components.td, {
            children: "no"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "sobel"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.h2, {
          id: "sobel-kernel",
          children: "Sobel kernel"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "X"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "2"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "2"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelX = \\begin{bmatrix}\n-1 & 0 & 1 \\\\\n-2 & 0 & 2 \\\\\n-1 & 0 & 1\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.07847em"
              },
              children: "lX"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "2"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "2"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "Y"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "2"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "2"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelY = \\begin{bmatrix}\n-1 & -2 & -1 \\\\\n0 & 0 & 0 \\\\\n1 & 2 & 1\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "l"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.22222em"
              },
              children: "Y"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "2"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "2"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.h2, {
          id: "scharr-kernel",
          children: "Scharr kernel"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "X"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "3"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "3"
                            })]
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "10"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "10"
                            })]
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "3"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "3"
                            })]
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelX = \\begin{bmatrix}\n3 & 0 & -3 \\\\\n10 & 0 & -10 \\\\\n3 & 0 & -3\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.07847em"
              },
              children: "lX"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "10"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "10"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "Y"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "3"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "10"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "3"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "3"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "10"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "3"
                            })]
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelY = \\begin{bmatrix}\n3 & 10 & 3 \\\\\n0 & 0 & 0 \\\\\n-3 & -10 & -3\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "l"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.22222em"
              },
              children: "Y"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "10"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "10"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "3"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.h2, {
          id: "prewitt-kernel",
          children: "Prewitt kernel"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "X"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelX = \\begin{bmatrix}\n1 & 0 & -1 \\\\\n1 & 0 & -1 \\\\\n1 & 0 & -1\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.07847em"
              },
              children: "lX"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsx(_components.p, {
      children: _jsxs(_components.span, {
        className: "katex",
        children: [_jsx(_components.span, {
          className: "katex-mathml",
          children: _jsx(_components.math, {
            xmlns: "http://www.w3.org/1998/Math/MathML",
            children: _jsxs(_components.semantics, {
              children: [_jsxs(_components.mrow, {
                children: [_jsx(_components.mi, {
                  children: "K"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "r"
                }), _jsx(_components.mi, {
                  children: "n"
                }), _jsx(_components.mi, {
                  children: "e"
                }), _jsx(_components.mi, {
                  children: "l"
                }), _jsx(_components.mi, {
                  children: "Y"
                }), _jsx(_components.mo, {
                  children: "="
                }), _jsxs(_components.mrow, {
                  children: [_jsx(_components.mo, {
                    fence: "true",
                    children: "["
                  }), _jsxs(_components.mtable, {
                    rowspacing: "0.16em",
                    columnalign: "center center center",
                    columnspacing: "1em",
                    children: [_jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "1"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsx(_components.mn, {
                            children: "0"
                          })
                        })
                      })]
                    }), _jsxs(_components.mtr, {
                      children: [_jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      }), _jsx(_components.mtd, {
                        children: _jsx(_components.mstyle, {
                          scriptlevel: "0",
                          displaystyle: "false",
                          children: _jsxs(_components.mrow, {
                            children: [_jsx(_components.mo, {
                              children: "−"
                            }), _jsx(_components.mn, {
                              children: "1"
                            })]
                          })
                        })
                      })]
                    })]
                  }), _jsx(_components.mo, {
                    fence: "true",
                    children: "]"
                  })]
                })]
              }), _jsx(_components.annotation, {
                encoding: "application/x-tex",
                children: "KernelY = \\begin{bmatrix}\n1 & 1 & 1 \\\\\n0 & 0 & 0 \\\\\n-1 & -1 & -1\n\\end{bmatrix}"
              })]
            })
          })
        }), _jsxs(_components.span, {
          className: "katex-html",
          "aria-hidden": "true",
          children: [_jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "0.6944em"
              }
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.02778em"
              },
              children: "Ker"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "n"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              children: "e"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.01968em"
              },
              children: "l"
            }), _jsx(_components.span, {
              className: "mord mathnormal",
              style: {
                marginRight: "0.22222em"
              },
              children: "Y"
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            }), _jsx(_components.span, {
              className: "mrel",
              children: "="
            }), _jsx(_components.span, {
              className: "mspace",
              style: {
                marginRight: "0.2778em"
              }
            })]
          }), _jsxs(_components.span, {
            className: "base",
            children: [_jsx(_components.span, {
              className: "strut",
              style: {
                height: "3.6em",
                verticalAlign: "-1.55em"
              }
            }), _jsxs(_components.span, {
              className: "minner",
              children: [_jsx(_components.span, {
                className: "mopen",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M403 1759 V84 H666 V0 H319 V1759 v0 v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              }), _jsx(_components.span, {
                className: "mord",
                children: _jsxs(_components.span, {
                  className: "mtable",
                  children: [_jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "arraycolsep",
                    style: {
                      width: "0.5em"
                    }
                  }), _jsx(_components.span, {
                    className: "col-align-c",
                    children: _jsxs(_components.span, {
                      className: "vlist-t vlist-t2",
                      children: [_jsxs(_components.span, {
                        className: "vlist-r",
                        children: [_jsxs(_components.span, {
                          className: "vlist",
                          style: {
                            height: "2.05em"
                          },
                          children: [_jsxs(_components.span, {
                            style: {
                              top: "-4.21em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-3.01em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsx(_components.span, {
                              className: "mord",
                              children: _jsx(_components.span, {
                                className: "mord",
                                children: "0"
                              })
                            })]
                          }), _jsxs(_components.span, {
                            style: {
                              top: "-1.81em"
                            },
                            children: [_jsx(_components.span, {
                              className: "pstrut",
                              style: {
                                height: "3em"
                              }
                            }), _jsxs(_components.span, {
                              className: "mord",
                              children: [_jsx(_components.span, {
                                className: "mord",
                                children: "−"
                              }), _jsx(_components.span, {
                                className: "mord",
                                children: "1"
                              })]
                            })]
                          })]
                        }), _jsx(_components.span, {
                          className: "vlist-s",
                          children: "​"
                        })]
                      }), _jsx(_components.span, {
                        className: "vlist-r",
                        children: _jsx(_components.span, {
                          className: "vlist",
                          style: {
                            height: "1.55em"
                          },
                          children: _jsx(_components.span, {})
                        })
                      })]
                    })
                  })]
                })
              }), _jsx(_components.span, {
                className: "mclose",
                children: _jsx(_components.span, {
                  className: "delimsizing mult",
                  children: _jsxs(_components.span, {
                    className: "vlist-t vlist-t2",
                    children: [_jsxs(_components.span, {
                      className: "vlist-r",
                      children: [_jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "2.05em"
                        },
                        children: _jsxs(_components.span, {
                          style: {
                            top: "-4.05em"
                          },
                          children: [_jsx(_components.span, {
                            className: "pstrut",
                            style: {
                              height: "5.6em"
                            }
                          }), _jsx(_components.span, {
                            style: {
                              width: "0.667em",
                              height: "3.600em"
                            },
                            children: _jsx(_components.svg, {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "0.667em",
                              height: "3.600em",
                              viewBox: "0 0 667 3600",
                              children: _jsx(_components.path, {
                                d: "M347 1759 V0 H0 V84 H263 V1759 v0 v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v0 v1759 h84z"
                              })
                            })
                          })]
                        })
                      }), _jsx(_components.span, {
                        className: "vlist-s",
                        children: "​"
                      })]
                    }), _jsx(_components.span, {
                      className: "vlist-r",
                      children: _jsx(_components.span, {
                        className: "vlist",
                        style: {
                          height: "1.55em"
                        },
                        children: _jsx(_components.span, {})
                      })
                    })]
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), "\n", _jsxs(_components.admonition, {
      type: "info",
      children: [_jsx(_components.p, {
        children: "As was mentioned, derivative filter is a type of gradient filter. Therefore using the same kernels with gradient filter will provide the same image output. Derivative filter simplifies some kernel's application."
      }), _jsx(_components.p, {
        children: _jsx(_components.em, {
          children: "Applying Sobel kernel using gradient filter"
        })
      }), _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-js",
          children: "return image.gradientFilter({\n  kernelX: [\n    [-1, 0, 1],\n    [-2, 0, 2],\n    [-1, 0, 1],\n  ],\n  kernelY: [\n    [-1, -2, -1],\n    [0, 0, 0],\n    [1, 2, 1],\n  ],\n});\n"
        })
      }), _jsx(_components.p, {
        children: _jsx(_components.em, {
          children: "Applying Sobel kernel using derivative filter"
        })
      }), _jsx(_components.pre, {
        children: _jsx(_components.code, {
          className: "language-js",
          children: "return image.derivativeFilter({ filter: 'sobel' });\n"
        })
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

